/* eslint-disable */
<template>
    <div>

      <vx-card title="Filtros">

        <div class="vx-row mb-4">
          <div class="vx-col w-1/2">
            <label>CNPJ</label>
            <NumericInput
              v-model="cnpj"
              name="cnpj"
              :is-cnpj="true"
              class="w-full"/>
          </div>
          <div class="vx-col w-1/2">
            <label>Data</label>
            <date-picker
              v-model="date"
              v-validate="'required'"
              name="data"
              placeholder="Data do portfolio"
              format="DD-MM-YYYY"
              value-type="YYYY-MM-DD"
              class="w-full"/>
          </div>
        </div>

        <div class="vx-row mb-4">
          <div class="vx-col w-1/3">
            <label>Operação</label>
            <vs-select
              v-model="operationType"
              autocomplete
              class="w-full d-inline">
              <vs-select-item :key="index" :value="item" :text="item" v-for="(item, index) in operationTypes" />
            </vs-select>
          </div>
          <div class="vx-col w-1/3">
            <label>Energia</label>
            <vs-select
              v-model="energy"
              autocomplete
              class="w-full ml-2 d-inline">
              <vs-select-item :key="index" :value="item" :text="item" v-for="(item, index) in energies" />
            </vs-select>
          </div>
          <div class="vx-col w-1/3">
            <label>Mercado</label>
            <vs-select
              v-model="mercado"
              autocomplete
              class="w-full ml-2 d-inline">
              <vs-select-item :key="index" :value="item" :text="item" v-for="(item, index) in mercados" />
            </vs-select>
          </div>
        </div>

        <div class="vx-row mb-4">
          <div class="vx-col w-1/3">
            <vs-button class="bg-primary" @click="updateOperation">Caregar balanço energético</vs-button>
          </div>
        </div>
      </vx-card>

      <vx-card class="mt-4">
        <VueApexCharts type="bar" height="400" :options="chartOptions" :series="series"></VueApexCharts>
      </vx-card>

    </div>
</template>

<script>

import axios from 'axios'
import VueApexCharts from 'vue-apexcharts'
import ptbr from 'apexcharts/dist/locales/pt-br.json'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/pt-br'
import NumericInput from '../../components/NumericInput'

export default {
  name: 'BalancoEnergeticoStats',
  components: {
    VueApexCharts,
    ptbr,
    DatePicker,
    NumericInput
  },
  data () {
    return {
      cnpj: null,
      operationType: null,
      operationTypes: [null, 'Compra', 'Venda'],
      mercado: null,
      mercados: [null, 'Sul', 'Sudeste', 'Norte', 'Nordeste'],
      energy: null,
      energies: [null, 'Convencional', 'Incentivada 100%', 'Incentivada 80%', 'Incentivada 50%', 'Incentivada 0%', 'CQ5'],
      date: null,
      longChart: [],
      shortChart: [],
      series: [],

      chartOptions: {
        colors: ['#6381c5', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E'],
        chart: {
          type: 'bar',
          stacked: true,
          locales: [ptbr],
          defaultLocale: 'pt-br'
        },
        plotOptions: {
          bar: {
            columnWidth: '80%',
            dataLabels: {
              position: 'bottom' // top, center, bottom
            },
            colors: {
              ranges: [
                {
                  from: 0,
                  to: 0,
                  color: ['#6381c5', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E']
                }
              ],
              backgroundBarColors: [],
              backgroundBarOpacity: 1,
              backgroundBarRadius: 0
            }
          }
        },
        animations: {
          enabled: false
        },
        fill: {
          opacity: [0.85, 0.25, 1],
          gradient: {
            inverseColors: false,
            shade: 'light',
            type: 'vertical',
            opacityFrom: 0.85,
            opacityTo: 0.55,
            stops: [0, 100, 100, 100]
          }
        },
        dataLabels: {
          enabled: false,
          formatter (val) {
            return val
          },
          offsetY: -20,
          style: {
            fontSize: '12px',
            colors: ['#6381c5']
          }
        },
        legend: {
          position: 'right',
          offsetY: 40
        },
        xaxis: {
          type: 'datetime',
          categories: []
        },
        yaxis: {
          labels: {
            formatter (value) {
              return `R$${  value.toFixed(2)}`
            },
            title: {
              text: 'Total'
            },
            min: 0
          }
        }

      }
    }
  },
  beforeMount () {
    this.loadOperationStats()
  },
  methods: {

    updateOperation () {

      axios.get(`${process.env.VUE_APP_API  }/api/v1/operation-chart`,
        {
          params:{
            cnpj: this.cnpj,
            energy: this.energy,
            mercado: this.mercado,
            operation: this.operationType,
            date: this.date
          }
        })
        .then((response) => {
          response.data.name = 'Balanço'
          this.series.pop()
          if (response.data.data.length === 0) {
            return
          }
          this.series.push(response.data)
          this.chartOptions.xaxis.categories.pop()
          this.chartOptions = {
            xaxis: {
              categories: response.data.categories
            }
          }
        })

    },

    loadOperationStats () {
      this.series = []

      axios.get(`${process.env.VUE_APP_API  }/api/v1/operation-chart`,
        {
          params:{
            cnpj: null,
            energy: null,
            mercado: null,
            operation: 'Compra',
            date: '2028-01-01'
          }
        })
        .then((response) => {
          response.data.name = 'Compra'
          this.series.push(response.data)
          this.chartOptions = {
            xaxis: {
              categories: response.data.categories
            }
          }
        })

      axios.get(`${process.env.VUE_APP_API  }/api/v1/operation-chart`,
        {
          params:{
            cnpj: null,
            energy: null,
            mercado: null,
            operation: 'Venda',
            date: '2028-01-01'
          }
        })
        .then((response) => {
          response.data.name = 'Venda'
          this.series.push(response.data)
        })
    }
  }
}
</script>

<style scoped>

</style>
